import styled, { css } from "styled-components";



export const MainTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const MainTabsList = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const MainTabsItem = styled.div`
    position: relative;
    font-weight: 400;
    cursor: pointer;
    font-size: 15px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    color: ${props => props.active ? '#2555EF' : '#7B7B8B'};
    ${(props) =>
      props.active &&
      css`
        &:after {
          content: "";
          width: 100%;
          height: 4px;
          background-color: #2555ef;
          border-radius: 6px;
          position: absolute;
          bottom: -2px;
        }
    `}

    
`

export const MainTabsSeparator = styled.div`
    background-color: #e7e7e7;
    width: 100%;
    height: 1px;

`